var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"euro-amount"},[(_vm.show)?[(_vm.value === 0.0)?_c('span',[_vm._v("\n      0,00 €\n    ")]):_c('vue-numeric',{attrs:{"value":_vm.value,"separator":".","precision":2,"read-only":true,"currency":"€","currency-symbol-position":"suffix"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }